import { ContentfulImage } from "../Contentful/Image";
import MuxVideo from "@mux/mux-player-react";
import { Link } from "../Actions";
import { default as NextLink } from "next/link";

import { useEffect, useState } from "react";
import usePlaybackTime from "../../hooks/usePlaybackTime";

const TokenGatedVideo: React.FC<{
  isHolder: boolean;
  address?: string;
  video: any;
}> = ({ video, isHolder, address }) => {
  const [videoEl, setVideoEl] = useState<any>(null);
  const secondsElapsed = usePlaybackTime(videoEl);
  const [hasTimeElapsed, setHasTimeElapsed] = useState(false);

  useEffect(() => {
    if (secondsElapsed >= 45) {
      setHasTimeElapsed(true);
    }
  }, [secondsElapsed]);

  if (!video) return null;

  return !isHolder && hasTimeElapsed ? (
    <div className="relative flex min-h=[310px]">
      <div className="flex absolute z-20 w-full h-full bg-coinage-blue/80 text-coinage-white">
        <div className="flex m-auto w-[96%] flex-col pt-[4px]">
          <h3 className="display3 mb-[10px] tab:mb-[15px] text-center">
            EPISODE LOCKED
          </h3>
          <p className="body2 w-[88%] tab:w-[67%] mx-auto mb-[15px] tab:mb-[25px] text-center">
            Connect your wallet if you have a{" "}
            <NextLink href="/about#mint" className="underline">
              Coinage Membership Pass
            </NextLink>{" "}
            Or,{" "}
            <NextLink className="underline" href="/trial/mint">
              snag a 30-day Trial Pass
            </NextLink>{" "}
            to unlock all our stories.
            <div className="flex flex-col tab:flex-row justify-center mt-4 gap-2 tab:gap-4">
              <Link
                analyticsProperty="mint"
                modifier="secondary"
                href="/about#mint">
                Mint Membership Pass
              </Link>
              <Link
                analyticsProperty="mint"
                modifier="secondary"
                href="/trial/mint">
                Mint Trial Pass
              </Link>
            </div>
          </p>
        </div>
      </div>

      <div className="z-1 w-full h-full blur-sm">
        <ContentfulImage image={video?.fallbackImage} />
      </div>
    </div>
  ) : (
    <MuxVideo
      poster={video?.fallbackImage.url}
      style={{ height: "100%", maxWidth: "100%" }}
      playbackId={video.videoUpload.playbackId}
      ref={muxPlayerEl => {
        setVideoEl(muxPlayerEl?.media?.nativeEl);
      }}
      metadata={{
        video_id: video.sys.id,
        video_title: video.videoTitle,
        viewer_user_id: address
      }}
      streamType="on-demand"
      envKey="ecouuj70pqac6n54q65p027j0"
    />
  );
};

export default TokenGatedVideo;
